import {selectAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/react'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import opacity from '../foundations/opacity'
import shadow from '../foundations/shadow'
import size from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(selectAnatomy.keys)

// Using outline variant as the default value since this is the only way to change field borderColor
const outline = definePartsStyle({
  field: {
    ...typography.textStyles.body.medium,
    borderRadius: borders.radii['2xs'],
    minW: size['4xl'],
    maxW: '1280px',
    direction: 'horizontal',
    alignItems: ['middle', 'left'],
    resize: 'horizontal',
    background: colors.background.primary,
    color: colors.text.primary,
    _hover: {
      backgroundColor: colors.background['primary-hover'],
    },
    _focusVisible: {
      borderColor: colors.border.brand,
      boxShadow: colors.border.brand,
      borderWidth: '2px',
    },
    _focus: {
      shadow: shadow.focus,
    },
    _invalid: {
      ringColor: colors.border.error,
    },
    _disabled: {
      opacity: opacity.disabled,
    },
  },
})

const sizes = {
  sm: definePartsStyle({
    field: defineStyle({
      h: size.sm,
      paddingY: spacing['6xs'],
      paddingStart: spacing['4xs'],
    }),
  }),
  md: definePartsStyle({
    field: defineStyle({
      h: size.md,
      paddingY: spacing['5xs'],
      paddingStart: spacing['3xs'],
    }),
  }),
  xl: definePartsStyle({
    field: defineStyle({
      h: size.lg,
      paddingY: spacing['4xs'],
      paddingStart: spacing.xs,
    }),
  }),
}

const selectTheme = defineMultiStyleConfig({
  variants: {outline},
  sizes,
  defaultProps: {variant: 'outline'},
})

export default selectTheme
